export default __webpack_public_path__ + "static/from-script-to-screen-header-50b746aacb213a6e6de1292fde481ce0aa1bc626afc8ccc456ff0a7f8d09d9f5.png";